import React from 'react'
import styled from '@emotion/styled'
import { color } from 'stylist'

const SVG = styled.svg`
  stroke: ${({ stroke, theme }) => stroke && color(stroke, { theme })};
  fill: none;
  stroke-width: 2;
  stroke-miterlimit: 10;
`

const RightArrow = props => (
  <SVG role="img" viewBox="0 0 63.2 37.4" width="100%" height="100%" {...props}>
    <title>arrow-right</title>
    <path d="M49.3 36.8L62 18.1 49.3.6M62 18.1H0" />
  </SVG>
)

export default RightArrow



// WEBPACK FOOTER //
// ./src/components/icons/RightArrow.js